module.exports = {
	"header": "Phone numbers",
	"addPhone": "Add phone number",
	"enterPhone": "Enter phone number",
	"removeConfirmation": "Are you sure you want to remove <phone /> from your phone numbers?",
	"successfullyAdded": "Successfully added new phone number",
	"successfullyRemoved": "Successfully removed phone number"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/phone.json5
// module id = 1953
// module chunks = 6